import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS
} from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { HttpCacheInterceptor, SentryErrorHandler } from '@core/services/common';
import { HttpInterceptorError } from '@core/services/core/interceptors/http-interceptor-error';
import { HttpMockInterceptorService } from '@core/services/core/interceptors/http-mock-interceptor';
import { TokenInterceptorService } from '@core/services/core/interceptors/token-interceptor.service';
import { IonicModule } from '@ionic/angular';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { SharedModule } from '../shared/shared.module';
import { ApiModule } from './services/http-services/swagger-familias/providers/api.module';

export function HttpLoaderFactory(http: HttpClient) {
  return new MultiTranslateHttpLoader(http, [
    { prefix: 'assets/vehicle-accidents/i18n/core/vehicle-accidents/', suffix: '.json' },
    { prefix: './assets/i18n/core/', suffix: '.json' },
    { prefix: './assets/i18n/main/', suffix: '.json' },
    { prefix: './assets/i18n/receipt-payment/', suffix: '.json' },
    { prefix: './assets/i18n/road-assistance/', suffix: '.json' },
    { prefix: './assets/i18n/road-assist-tracing/', suffix: '.json' },
    { prefix: './assets/i18n/refund/', suffix: '.json' },
    { prefix: './assets/i18n/locator/', suffix: '.json' },
    { prefix: './assets/i18n/documents/', suffix: '.json' },
    { prefix: './assets/i18n/additional-coverages/', suffix: '.json' },
    { prefix: './assets/i18n/tecuidamos/', suffix: '.json' },
    { prefix: './assets/i18n/client-area/', suffix: '.json' },
    { prefix: './assets/i18n/contact/', suffix: '.json' },
    { prefix: './assets/i18n/ca-health-refund/', suffix: '.json' },
    { prefix: './assets/i18n/ca-health-authorization/', suffix: '.json' },
    { prefix: './assets/i18n/car-sinister/', suffix: '.json' },
    { prefix: './assets/i18n/car-sinister-without-contrary/', suffix: '.json' },
    { prefix: './assets/i18n/car-sinister-consultation/', suffix: '.json' },
    { prefix: './assets/i18n/car-sinister-repair/', suffix: '.json' },
    { prefix: './assets/i18n/car-change-product/', suffix: '.json' },
    { prefix: './assets/i18n/ca-home/', suffix: '.json' },
    { prefix: './assets/i18n/families/', suffix: '.json' },
    { prefix: './assets/i18n/superbonus/', suffix: '.json' },
    { prefix: './assets/i18n/payment-plan/', suffix: '.json' },
    { prefix: './assets/i18n/inbox/', suffix: '.json' },
    { prefix: './assets/i18n/login/', suffix: '.json' },
    { prefix: './assets/i18n/profile/', suffix: '.json' },
    { prefix: './assets/i18n/help/', suffix: '.json' },
    { prefix: './assets/i18n/rating/', suffix: '.json' },
    { prefix: './assets/i18n/register/', suffix: '.json' },
    { prefix: './assets/i18n/pwa-patrimonials/', suffix: '.json' },
    { prefix: './assets/i18n/update-doc/', suffix: '.json' },
    { prefix: './assets/i18n/bank-data/', suffix: '.json' },
    { prefix: './assets/i18n/vehicle-data/', suffix: '.json' },
    { prefix: './assets/i18n/businesses/', suffix: '.json' },
    { prefix: './assets/i18n/will-management/', suffix: '.json' },
    { prefix: './assets/i18n/medical-headquarters/', suffix: '.json' }
  ]);
}
@NgModule({
  imports: [
    SharedModule,
    IonicModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    ApiModule
  ],
  exports: [TranslateModule],
  providers: [
    { provide: ErrorHandler, useClass: SentryErrorHandler },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptorService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpInterceptorError, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpCacheInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpMockInterceptorService, multi: true }
  ]
})
export class CoreModule {}
